var arabam;
(function (arabam) {
    var miniToggle = /** @class */ (function () {
        function miniToggle($compile) {
            this.$compile = $compile;
            this.restrict = 'A';
            this.link = function ($scope, element, attributes, modelCtrl) {
                var toggler, storage, isMobile;
                try {
                    toggler = JSON.parse(localStorage.getItem("togglerV2"));
                    storage = typeof (Storage) !== "undefined";
                }
                catch (e) {
                    storage = false;
                }
                var hrefElement = $(element).next(), self = $scope.self, attr = attributes.miniToggleVisible;
                isMobile = window.configuration.IsMobile;
                self.toggler = self.toggler ? self.toggler : {};
                if (toggler) {
                    self.toggler = toggler;
                }
                else if (!self.toggler.hasOwnProperty()) {
                    if (isMobile)
                        self.toggler[attr] = false;
                    else {
                        if (attr !== "multi-category") {
                            self.toggler[attr] = false;
                        }
                        else {
                            self.toggler[attr] = toggler && toggler[attr] ? toggler[attr] : true;
                        }
                    }
                    if (storage) {
                        localStorage.setItem("togglerV2", JSON.stringify(self.toggler));
                    }
                }
                else {
                    // Sorry! No Web Storage support..
                }
                element.bind('click', function () {
                    $scope.$apply(function () {
                        self.toggler[attr] = !self.toggler[attr];
                        /** mobil facetlerde ac kapa esnasinda viewport icine girmesi gerekirse asagidaki satirlari uncomment edin */
                        /*const element = document.getElementById(attr);
                        if(element && isMobile)
                            element.scrollIntoView((<any>self).toggler[attr]);*/
                        if (storage) {
                            localStorage.setItem("togglerV2", JSON.stringify(self.toggler));
                        }
                    });
                });
            };
        }
        miniToggle.factory = function () {
            var directive = function ($compile) { return new miniToggle($compile); };
            directive.$inject = ['$compile'];
            return directive;
        };
        return miniToggle;
    }());
    angular
        .module('arabam')
        .directive('miniToggle', miniToggle.factory());
})(arabam || (arabam = {}));
